import service from "./service"

const submitPreCheckForm = async (data) => {
    return service(data)
}

export default submitPreCheckForm
